import { useEffect, useState } from "react";
import httpUtils from "@/utils/httpUtils";
import { env } from "@/next.config";

export const useStage = (props) => {
  if (props === undefined) {
    props = {};
  }
  const { searchVCDropdown, searchStartupDropdown } = props;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let params = {
        dropdown: true,
      };

      if (searchVCDropdown) {
        params = {
          searchVCDropdown: true,
        };
      }

      if (searchStartupDropdown) {
        params = {
          searchStartupDropdown: true,
        };
      }

      const response = await httpUtils.get(`${env.API_VERSION}/stage`, {
        params,
      });
      setData(response.data);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data.length === 0) {
      fetchData();
    }
  }, []);

  return { data, fetchData, isLoading };
};
